import React, { useEffect, useState } from 'react';
import moment from 'moment';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import { Spinner } from 'react-bootstrap';

const ClassInfo = ({ classeData }) => {
  const {getClassiUtentiByIdClasse, loadingStateClassiUtenti} = useClassiUtenti();
  const [classeUtenti, setClasseUtenti] = useState([]);

  useEffect(() => {
    if (classeData?.id_classe) {  
      fetchClasseUtenti();
    }
  }, [classeData]);

  const fetchClasseUtenti = async () => {
    const classId = {id_classe: classeData?.id_classe};
    const response = await getClassiUtentiByIdClasse(classId);
    setClasseUtenti(response);
  }

  const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
  };

  const groupUsersByRole = () => {
    const groups = {
      docenti: [],
      corsisti: [],
      course_designers: [],
      tutor: []
    };

    classeUtenti.forEach(user => {
      if (user.tipo_utente === 'docente') groups.docenti.push(user);
      else if (user.tipo_utente === 'corsista') groups.corsisti.push(user);
      else if (user.tipo_utente === 'course_designer') groups.course_designers.push(user);
      else if (user.tipo_utente === 'tutor') groups.tutor.push(user);
    });

    return groups;
  };

  const renderUserList = (users, role) => (
    <div className="row mb-3">
      <div className="col-12">
        <span className='small text-muted d-block'><b>{role}</b></span>
        {users.map(user => (
          <div key={user.id_utente} className="d-block">
            <span>{user.cognome} {user.nome}</span>
            {
              user.luogo_nascita && user.data_nascita && (
                <span className="ms-2 text-muted">({user.luogo_nascita}, {formatDate(user.data_nascita)})</span>
              )
            }
          </div>
        ))}
      </div>
    </div>
  );

  const groupedUsers = groupUsersByRole();

  if(loadingStateClassiUtenti.isLoadingClassiUtenti) {
    return (
      <div className='m-auto text-center'>
        <p>Caricando la classe...</p>
        <Spinner animation="border" role="status">
        <span className="visually-hidden">Caricamento...</span>
      </Spinner>
    </div>
    )
  }

  return (
    <div className='container'>
      <div className='row'>
        <div className='col-sm-12 col-md-6 my-2'>
          <span className='small text-muted d-block'><b>Classe</b></span>
          <span className='d-block'>{classeData?.denominazione || 'N/A'}</span>
        </div>
        <div className='col-sm-12 col-md-6 my-2'>
          <span className='small text-muted d-block'><b>Corso</b></span>
          <span className='d-block'>{classeData?.corso?.denominazione || 'N/A'}</span>
        </div>
      </div>

      <div className='row'>
        <div className='col-sm-12 col-md-6 my-2'>
          <span className='small text-muted d-block'><b>Data inizio classe</b></span>
          <span className='d-block'>{formatDate(classeData?.data_inizio) || 'N/A'}</span>
        </div>
        <div className='col-sm-12 col-md-6 my-2'>
          <span className='small text-muted d-block'><b>Data fine classe</b></span>
          <span className='d-block'>{formatDate(classeData?.data_fine) || 'N/A'}</span>
        </div>
      </div>

      <div className='row mt-2'>
        <div className='col-12'>
          {groupedUsers.course_designers.length > 0 && renderUserList(groupedUsers.course_designers, 'Course Designers')}
          {groupedUsers.docenti.length > 0 && renderUserList(groupedUsers.docenti, 'Docenti')}
          {groupedUsers.tutor.length > 0 && renderUserList(groupedUsers.tutor, 'Tutor')}
          {groupedUsers.corsisti.length > 0 && renderUserList(groupedUsers.corsisti, 'Corsisti')}
        </div>
      </div>
    </div>
  );
};

export default ClassInfo;
